module.exports = __webpack_public_path__ + "img/source04_8.780595de.png";